// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { showSuccess, showError } from "../actions/globalActions";
import cookie from "../utils/cookie";

const baseUrl = `${process.env.API_URL}/api/v1`;
// axios.defaults.headers.common["Authorization"] = `Bearer ${cookie.get("clerk_token")}`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useLocationStore = create(immer((set) => ({
  locations: [],
  seasons: [],

  // Asynchronous actions
  getLocationsByLeagueName: async (leagueName, options = {}) => {
    try {
      const { includeSubVenues = true } = options;
      const queryParams = includeSubVenues ? '?include=subVenues,parentLocation' : '';
      const { data } = await axios.get(`${baseUrl}/locations/organizationName/${leagueName}${queryParams}`);
      set((state) => {
        state.locations = data.result;
      });
    } catch (error) {
      console.error("Error in getLocationsByLeagueName:", error);
    }
  },

  // ... Continue with other actions ...
  updateLocations: (getToken) => {
    return async (location) => {
      try {
        const token = await getToken();
        const { data, status, error } = await axios.put(`${baseUrl}/locations/${location._id}`, location, createAuthHeader(token));
        console.log("updateLocations data: ", data, status, error);
        if (error) {
          showError("Error", "Update Error");
          return;
        } else {
          showSuccess("Success", "Successfully Updated");
          set((state) => {
            const index = state.locations.findIndex(d => d._id === location._id);
            if (index !== -1) {
              state.locations[index] = data.result;
            }
          });
        }
      } catch (error) {
        showError("Error", "Update Error");
        console.error("Error in updateLocations:", error);
      }
    }
  },

  // INT-0027 — create-on-type from the location combobox. Unlike the legacy
  // addLocation (fire-and-forget, no return), this RETURNS the created doc
  // and surfaces errors, which the combobox needs to select the new venue.
  createLocation: (getToken) => {
    return async (location) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(`${baseUrl}/locations`, location, createAuthHeader(token));
        if (data?.error) { showError('Error', data.error); return null; }
        set((state) => { state.locations.push(data.result); });
        return data.result;
      } catch (error) {
        console.error('Error in createLocation:', error);
        showError('Error', error?.response?.data?.error || 'Could not create the location.');
        return null;
      }
    }
  },

  addLocation: (getToken) => {
    return async (location) => {
      const token = await getToken();
      const { data } = await axios.post(`${baseUrl}/locations`, location, createAuthHeader(token));
      set((state) => {
        state.locations.push(data.result);
      });
    }
  },

  addLocationsAvailability: (getToken) => {
    return async (locationAvailability) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(`${baseUrl}/locations/availability`, locationAvailability, createAuthHeader(token));
        showSuccess("Success", "Successfully Added");
        set((state) => {
          state.locations.push(data.result);
        });
      } catch (error) {
        showError("Error", "Add Error");
        console.error("Error in addLocationsAvailability:", error);
      }
    }
  },

  deleteLocation: (getToken) => {
    return async (locationId) => {
      try {
        const token = await getToken();
        const { data }  = await axios.delete(`${baseUrl}/locations/${locationId}`, createAuthHeader(token), {});
        console.log('deleteLocation data: ', data, data.result);
        if (data.result) {
          showSuccess("Success", "Successfully Removed");
          set((state) => {
            state.locations = state.locations.filter((d) => d._id !== locationId);
          });
        } else {
          showError("Error", "Delete Error");
          return { error: "Delete Error" };
        }

      } catch (error) {
        showError("Error", "Delete Error");
        console.error("Error in deleteLocation:", error);
        return { error: "Delete Error" };
      }
    }
  },

})));

export default useLocationStore;